<template>
  <component :is="tag" :class="itemClasses">
    <div class="m-icon-text-item__image flex items-center">
      <RoundIcon
        v-if="useRoundIcon && icon"
        iconStyle="circle"
        :icon="icon"
        :theme="iconTheme"
        :size="iconSize"
      />
      <SvgIcon v-else-if="icon" :name="icon" :size="svgSize" />
    </div>
    <div class="m-icon-text-item__text-wrapper">
      <Heading
        v-if="title"
        tag="h3"
        role="title"
        :size="titleSize"
        :content="title"
        class="m-icon-text-item__text-wrapper__headline"
      />
      <Paragraph
        v-if="paragraph"
        :content="paragraph"
        class="m-icon-text-item__text-wrapper__paragraph"
      />
    </div>
  </component>
</template>

<script setup lang="ts">
import './IconTextItem.scss';
import { computed } from 'vue';
import Heading, { type HeadingProps } from '../../1-atoms/Heading/Heading.vue';
import Paragraph from '../../1-atoms/Paragraph/Paragraph.vue';
import RoundIcon, {
  type IconTheme,
  type RoundIconSize,
} from '../RoundIcon/RoundIcon.vue';
import SvgIcon, {
  type SvgIconSize,
} from '../../1-atoms/Icon/SvgIcon/SvgIcon.vue';

export interface IconTextItemProps {
  icon?: string;
  title?: string;
  paragraph?: string;
  useRoundIcon?: boolean;
  iconTheme?: IconTheme;
  iconSize?: RoundIconSize;
  svgSize?: SvgIconSize;
  titleSize?: HeadingProps['size'];
  tag?: 'div' | 'li';
  theme?: 'light' | 'dark';
}

const props = withDefaults(defineProps<IconTextItemProps>(), {
  icon: '',
  title: '',
  paragraph: '',
  useRoundIcon: true,
  iconTheme: 'dark',
  iconSize: 'small',
  svgSize: 'small',
  titleSize: 'large',
  tag: 'div',
  theme: 'light',
});

const itemClasses = computed(() => ({
  'm-icon-text-item': true,
  'm-icon-text-item--dark': props.theme === 'dark',
  'flex items-center gap-6': true,
}));
</script>
